const geolocationErrorCodes = {
  'invalid-coordinate-provided': 'invalid coordinate provided',
  'server-error-while-updating-coordinates': 'server error while updating coordinates',
  'error-while-updating-coordinates': 'error while updating coordinates',
  'server-error-while-getting-coordinates': 'server error while getting coordinates',
  'not-coordinates-funded': 'not coordinates funded'
};

export default geolocationErrorCodes;
